import React, { useState } from "react";

function Pesquisa({ dados = [], aoPesquisar }) {
  const [texto, setTexto] = useState("");

  function aplicarPesquisa() {
    let filtrados = dados;

    if (texto.trim() !== "") {
      filtrados = filtrados.filter((item) =>
        item.titulo.toLowerCase().includes(texto.toLowerCase()) ||
        item.descricao.toLowerCase().includes(texto.toLowerCase()) ||
        item.info.toLowerCase().includes(texto.toLowerCase())
      );
    }

    // envia resultados para o App
    aoPesquisar(filtrados);
  }

  return (
    <div>
      <h2>Pesquisa</h2>
      <input
        type="text"
        placeholder="Pesquisar por palavra..."
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
      />
      <button onClick={aplicarPesquisa}>Pesquisar</button>
    </div>
  );
}

export default Pesquisa;
